import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Section, Overline, QuoteBanner } from "../components/Shared";
import { Seo } from "../components/Seo";
import { REGIONS, regionPath } from "../lib/regions";

const CRUMBS = [["Locations", "/locations"]];

const RegionGrid = ({ title, regions, testId }) => (
  <div data-testid={testId}>
    <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">{title}</h2>
    <ul className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
      {regions.map((r) => (
        <li key={r.slug}>
          <Link
            to={regionPath(r)}
            data-testid={`location-link-${r.slug}`}
            className="group flex items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white px-4 py-3 text-base font-medium text-slate-800 shadow-sm hover:border-cyan-400 hover:text-cyan-800 hover:shadow-md transition-all"
          >
            <span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-cyan-600 shrink-0" />{r.name}</span>
            <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-cyan-600 group-hover:translate-x-0.5 transition-all" />
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default function Locations() {
  const states = REGIONS.filter((r) => r.country === "US");
  const provinces = REGIONS.filter((r) => r.country === "CA");
  return (
    <>
      <Seo page="locations" breadcrumbs={CRUMBS} />
      <Section className="pt-36">
        <div className="max-w-3xl">
          <Overline>Service Areas</Overline>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight leading-[1.1]">
            Lake &amp; reservoir mapping across the United States and Canada
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-slate-700 leading-relaxed">
            Our field crews travel to your waterbody with survey boat, sonar and GPS — wherever it is. Choose your
            state or province to see the lakes we map, the regional challenges we help solve, and the best time of
            year to schedule a survey.
          </p>
        </div>
      </Section>
      <Section className="pt-0 space-y-16">
        <RegionGrid title="United States — all 50 states" regions={states} testId="locations-us" />
        <RegionGrid title="Canada — all 10 provinces" regions={provinces} testId="locations-ca" />
      </Section>
      <QuoteBanner />
    </>
  );
}
